var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container px-0",
      attrs: { id: "recommend-or-compose-pack-navigation" },
    },
    [
      _c(
        "nav",
        {
          staticClass:
            "ob1-menu-page ob1-menu-page-fullscreen ob1-menu-page-icon",
          staticStyle: { height: "auto !important" },
        },
        [
          _c("ul", { staticClass: "nav ob1-nav-light" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.showBasicsOffers },
                staticStyle: { width: "50%" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "nav-link px-0",
                    attrs: {
                      "data-oevent-category": _vm.tmsTabInternetOffer.category,
                      "data-oevent-action": _vm.tmsTabInternetOffer.action,
                      "data-oevent-label": _vm.tmsTabInternetOffer.label,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeSelectedTab(
                          _vm.attributesTabInternetOfferId
                        )
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "item-icon",
                      class: _vm.attributesTabInternetOfferIcon,
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      _vm._s(_vm.attributesTabInternetOfferLabel) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: !_vm.showBasicsOffers },
                staticStyle: { width: "50%" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "nav-link px-0",
                    attrs: {
                      "data-oevent-category":
                        _vm.tmsTabInternetAndTvOffer.category,
                      "data-oevent-action": _vm.tmsTabInternetAndTvOffer.action,
                      "data-oevent-label": _vm.tmsTabInternetAndTvOffer.label,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeSelectedTab(
                          _vm.attributesTabInternetAndTvOfferId
                        )
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "item-icon",
                      class: _vm.attributesTabInternetAndTvOfferIcon,
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      _vm._s(_vm.attributesTabInternetAndTvOfferLabel) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }